const LOGO_SRC = "/jc-logo.webp";

export const Logo = ({ variant = "dark", size = "md" }) => {
  const isDark = variant === "dark"; // dark background (sidebar / hero)

  // Icon-only presentation: the logo image already carries "JUST COMPARE"
  // and "EDUCATIONAL & OFFICE SUPPLY" — no extra side text needed.
  const boxSize =
    size === "lg" ? "h-28 w-28" : size === "sm" ? "h-12 w-12" : "h-16 w-16";

  return (
    <div
      className={`inline-flex items-center justify-center rounded-md overflow-hidden ${boxSize} ${
        isDark ? "bg-white ring-1 ring-white/70 shadow-lg" : "bg-white"
      }`}
      data-testid="brand-logo"
    >
      <img
        src={LOGO_SRC}
        alt="Just Compare — Educational & Office Supply"
        className="h-full w-full object-contain"
      />
    </div>
  );
};
